<template>
  <div class="col">
    <ProductCard
      :product="product"
      :isAdmin="isAdmin"
      :daily-purchase-limit-amount="dailyPurchaseLimitAmount"
      :hot-products-disclaimer="hotProductsDisclaimer"
      :target-from-id="'productCardGridViewCard'"
      :payment_methods="payment_methods"
    />
  </div>
</template>

<script>
import ProductCard from "./../../ProductCard.vue"

export default {
  components: { ProductCard },
  props: ["product", "isAdmin", "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "payment_methods"]
}
</script>
